<div class="row" >
<mat-accordion>
  <mat-expansion-panel  [expanded]="panelOpenState" (opened)="panelOpenState = true"
                       (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
       Adicionar novos signatários
      </mat-panel-title>
      <mat-panel-description>

      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="row">

    <form [formGroup]="signatarioForm">
      <div class="row">
        <div class="form-group col-md-12">
          <mat-slide-toggle formControlName="estrangeiro">Signatário Estrangeiro</mat-slide-toggle>
     </div>
        <mat-form-field class="form-group col-md-5">
          <mat-label>Nome Completo</mat-label>
          <input matInput formControlName="nome" appRequiredField>
      </mat-form-field>
      <mat-form-field class="form-group col-md-3">
        <mat-label>Cpf</mat-label>
        <input matInput formControlName="cpf" appRequiredField>

    </mat-form-field>
    <mat-form-field class="form-group col-md-3">
        <mat-label>Rg</mat-label><input matInput  formControlName="rg">
    </mat-form-field>
    </div>
    <div class="row">

    <mat-form-field class="form-group col-md-4">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" appRequiredField>

  </mat-form-field>
        <mat-form-field class="col-md-3 col-xs-12 form-group">
            <mat-label>Assinar como:</mat-label>
            <mat-select formControlName="acao" appRequiredField>
              <mat-option *ngFor="let option of optionsAcao" [value]="option.value">{{ option.viewValue }}</mat-option>

            </mat-select>
        </mat-form-field>



        <div class="col-md-3" *ngIf="metodoAssinatura">


        <mat-slide-toggle formControlName="assinado" > Assinou o Contrato</mat-slide-toggle>

        </div>
        <div class="col-md-2">
          <button mat-mini-fab class="add" matTooltip="Adicionar Signatário"
            (click)="addSignatario()"
            [disabled]="signatarioForm.invalid || BloquearEdicao">
            <mat-icon>add</mat-icon>
          </button>
          </div>


    </div>
  </form>

  </div>
  </mat-expansion-panel>
</mat-accordion>
</div>
<hr>

    <div class="row"  *ngIf="signatariosContrato.data.length>0">
        <app-table fixed
        [dataSource]="signatariosContrato"
        [columns]="columnsSignatario"
        [enablePagination]="false"
        [onExcluir]="onExcluirSignatario.bind(this)"
        [itemIdProperty] ="'id'"  class="servico-table"
        [BloquearEdicao]="BloquearEdicao">
    </app-table>
    </div>
